import React from 'react';
import { CardBody, Card, Row, Col } from 'reactstrap';
import CurrencyFormat from 'react-number-format';
import NoRecordLogo from '../../../assets/logo/No_record_logo.png';
import ContentLoader from '../../../components/ContentLoader';
import { useDict } from '../../../contexts/LanguageContext';
import { yearMonthFormatter } from '../../../utils/dateHelper';

const ByMonth = ({ Income, Data, isLoading }) => {
    const dict = useDict();
    const language = localStorage.getItem('language') === 'en' ? 'en' : 'th';

    if (isLoading) {
        return (
            <ContentLoader width="100%" height="190" topBottom>
                <rect width="100%" height="100%" y="0" rx="10" ry="10" />
            </ContentLoader>
        );
    }

    if (Income !== undefined && Object.keys(Income).length > 0) {
        return (
            <div>
                {Object.entries(Income).map(([month, data]) => (
                    <Card className="grid margin-bottom-10" key={month}>
                        <CardBody style={{ textAlign: 'left' }}>
                            <h5
                                style={{
                                    color: '#1124A6',
                                    fontWeight: 'bold',
                                    marginLeft: '20px',
                                }}
                            >
                                {Data} {yearMonthFormatter(month, language)}
                            </h5>
                            {Data === dict.expectedIncomeFor ? (
                                <Row style={{ margin: '15px 0 0 0' }}>
                                    <Col md={5} xs={6}>
                                        {dict.profitExpected}
                                    </Col>
                                    <Col
                                        md={7}
                                        xs={6}
                                        style={{ textAlign: 'right' }}
                                    >
                                        <CurrencyFormat
                                            value={parseFloat(
                                                data['profit_return'] ?? 0
                                            ).toFixed(2)}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="฿ "
                                        />
                                    </Col>
                                </Row>
                            ) : (
                                <Row style={{ margin: '15px 0 0 0' }}>
                                    <Col md={5} xs={6}>
                                        {dict.profitReceived}
                                    </Col>
                                    <Col
                                        md={7}
                                        xs={6}
                                        style={{ textAlign: 'right' }}
                                    >
                                        <CurrencyFormat
                                            value={parseFloat(
                                                data['profit_return'] ?? 0
                                            ).toFixed(2)}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="฿ "
                                        />
                                    </Col>
                                </Row>
                            )}
                            {/* <Row style={{ margin: '0' }}>
                                <Col md={5} xs={6}>
                                    + Late Profit
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{ textAlign: 'right' }}
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data.lateProfit ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row>
                            <Row style={{ margin: '0px' }}>
                                <Col md={5} xs={6}>
                                    + Other Income
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{ textAlign: 'right' }}
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data.otherIncome ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row>
                            <Row style={{ margin: '0px' }}>
                                <Col md={5} xs={6}>
                                    + Recovered Amount
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{ textAlign: 'right' }}
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data.recoveries ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row> */}
                            <Row style={{ margin: '0px' }}>
                                <Col md={5} xs={6}>
                                    - {dict.serviceFees}
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{ textAlign: 'right' }}
                                    className="fee-text"
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data['service_fee'] ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row>
                            {/* <Row style={{ margin: '0px' }}>
                                <Col md={5} xs={6}>
                                    - Defaulted Amount
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{ textAlign: 'right' }}
                                    className="fee-text"
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data.defaults ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row> */}
                            <Row
                                style={{
                                    margin: '5px 0 0 0',
                                    fontWeight: 'bold',
                                    background:
                                        'linear-gradient(90deg, #F29525, #F4BE23)',
                                    color: 'white',
                                }}
                            >
                                <Col
                                    md={5}
                                    xs={6}
                                    style={{
                                        height: '30px',
                                        paddingTop: '5px',
                                    }}
                                >
                                    {dict.netReturn}
                                </Col>
                                <Col
                                    md={7}
                                    xs={6}
                                    style={{
                                        height: '30px',
                                        paddingTop: '5px',
                                        textAlign: 'right',
                                    }}
                                >
                                    <CurrencyFormat
                                        value={parseFloat(
                                            data['net_return'] ?? 0
                                        ).toFixed(2)}
                                        displayType="text"
                                        thousandSeparator
                                        prefix="฿ "
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                ))}
            </div>
        );
    }
    return (
        <Col md={12}>
            <div className="d-flex flex-column align-items-center mt-4 mb-4">
                <img
                    src={NoRecordLogo}
                    className="recording"
                    style={{ marginBottom: '5%' }}
                    alt="no_record"
                />
                <p className="font-size-20">{dict.noRecordAvailable}</p>
            </div>
        </Col>
    );
};

export default ByMonth;
